import { datalakeSerializer } from '@/providers/serializers/data-lake/data-lake';
import { http } from '../http';

export class DataLakeAPI {

    private static INSTANCE = new DataLakeAPI();

    static get instance() {
        return this.INSTANCE;
    }

    private namespace: string = 'api/admin/v1/datalake';

    public fetchDataLake(params: any = {}) {
        const endpoint = `${this.namespace}/stats`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params).then((response) => {
            return datalakeSerializer.normalizeDatalakeData(response.data);
        });
    }

    public fetchFilesByToolId(providerType: string, params: any) {
        const endpoint =  `${this.namespace}/stats/${providerType}`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params).then((response) => {
            return datalakeSerializer.normalizeDatalakeTools(response.data);
        });
    }

}

export const dataLakeAPI = DataLakeAPI.instance;
